// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ec3e242b","160":"ab3b73a3","208":"9f42ae3e","293":"fbf92fdf","516":"5ec6b2a1","519":"54060bf2","917":"302f0cb6","946":"d3cf7b8e"}[chunkId] + ".chunk.js";
};